import React, { useRef, useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import { Document, Page, pdfjs } from "react-pdf";
import { blobToURL } from "../../utils/Utils";
import Drop from "./Drop";
import { BigButton } from "./BigButton";
import DraggableText from "./DraggableText";
import TodoList from "./TodoList";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { AuthContext } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";
import { UserTypeContext } from "../../context/UserTypeContext";
import { Button, Modal, ModalBody, Col, Container, Row } from "reactstrap";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { useToast } from "../../context/ToastContext";
import { SettingsContext } from "../../context/SettingsContext";
import { jwtDecode } from "jwt-decode";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PdfEditor() {
  const {
    createDocument,
    createDocumentSignType,
    document,
    setNameDocument,
    signersEdit,
    updateDocumentSignType,
    idEditDocument,
    setIdEditDocument,
    setCollaborators,
    collaborators,
    setTutorial,
    tutorial,
    tableDocuments,
    templatePlaceholders,
    setTemplatePlaceholders,
    templateRequiredSignersCount,
    setTemplateRequiredSignersCount,
  } = useContext(DocumentTypeContext);

  const { formValuesUsers } = useContext(UserTypeContext);
  const { getMessageTitleByUserId, messageTitle, messageEmailBody } =
    useContext(SettingsContext);
  const [pdf, setPdf] = useState(document || null);
  const [pageNum, setPageNum] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageDetails, setPageDetails] = useState(null);
  const [components, setComponents] = useState([]);
  const [blurEnabled, setBlurEnabled] = useState(false);
  const documentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(true);
  const navigate = useNavigate();

  const [selectedCollaboratorName, setSelectedCollaboratorName] =
    useState(null);
  const [selectedCollaboratorEmail, setSelectedCollaboratorEmail] =
    useState(null);
  const [selectedCollaboratorPhoneNumber, setSelectedCollaboratorPhoneNumber] =
    useState(null);
  const [
    selectedCollaboratorAddToContacts,
    setSelectedCollaboratorAddToContacts,
  ] = useState(null);
  const [
    selectedCollaboratorSendMessageWhatsApp,
    setSelectedCollaboratorSendMessageWhatsApp,
  ] = useState(null);
  const [
    selectedCollaboratorRequireSignerDocument,
    setSelectedCollaboratorRequireSignerDocument,
  ] = useState(null);
  const [
    selectedCollaboratorSignPosition,
    setSelectedCollaboratorSignPosition,
  ] = useState(null);

  const location = useLocation();
  const showToast = useToast();
  const url = window.location.href;
  const urlObj = new URL(url);
  let token = urlObj.searchParams.get("token");

  const isSpecificRoute =
    location.pathname === "/admin/create-documents" &&
    new URLSearchParams(location.search).has("edit");

  const routeCreateOrUpdateDocument =
    location.pathname === "/admin/create-documents" ||
    new URLSearchParams(location.search).has("documentId");

  const routeSign = location.pathname.startsWith("/admin/sign-document");
  const isMobileDevice = window.innerWidth < 768;
  /** Na assinatura no celular: sem scroll preso no PDF — só o scroll da página. */
  const signMobilePageScroll = routeSign && isMobileDevice;

  const toPainel = urlObj.searchParams.get("sign");
  const toEdit = urlObj.searchParams.get("edit");

  let objUserTk;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token"));
  } else {
    objUserTk = {};
  }

  useEffect(() => {
    localStorage.setItem("savedComponents", JSON.stringify(components));
  }, [components]);

  useEffect(() => {
    if (document) {
      setPdf(null);
      setTotalPages(0);
      setPageNum(0);
      setPageDetails(null);
      setBlurEnabled(true);

      openFile(document);
    }
  }, [document]);

  useEffect(() => {
    if (objUserTk.UserId && toPainel !== "true" && !token) {
      getMessageTitleByUserId(objUserTk.UserId);
    }
  }, []);

  useEffect(() => {
    if (tableDocuments.length === 0 && !routeSign) {
      setTutorial(true);
    }
  }, []);

  const openFile = async (result) => {
    const blobUrl = await getOpenFile(".pdf", result);
    //@ts-ignore
    setPdf(blobUrl);
  };

  function isValidBase64(str) {
    try {
      return btoa(atob(str)) === str;
    } catch (error) {
      return false;
    }
  }

  async function getOpenFile(typeFile, result) {
    try {
      const base64Data = result.split(",").pop() || "";

      if (!isValidBase64(base64Data)) {
        throw new Error(
          "A string fornecida não está codificada corretamente em Base64.",
        );
      }

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const mimeTypes = {
        ".pdf": "application/pdf",
        ".xlsx":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ".jpeg": "image/jpeg",
        ".jpg": "image/jpg",
        ".png": "image/png",
        ".docx":
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ".pptx":
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      };

      const mimeType = mimeTypes[typeFile] || "application/octet-stream";

      // Evita dependência de blob: URL no fluxo de envio.
      // Assim conseguimos reutilizar o mesmo conteúdo diretamente em Base64.
      return `data:${mimeType};base64,${base64Data}`;
    } catch (error) {
      console.error("Erro ao processar o arquivo:", error);
      throw error;
    }
  }

  function buildSignerActionsRequest(components) {
    const groupedByEmail = {};

    collaborators.forEach((collab) => {
      groupedByEmail[collab.email] = {
        addToContacts: collab.addToContacts,
        sendMessageWhatsApp: collab.sendMessageWhatsApp,
        requireSignerDocument: collab.requireSignerDocument,
        signPosition: collab.signPosition,
        // Opt-out da assinatura automática marcado na tela de signatários.
        disableAutoSign: collab.disableAutoSign ?? false,
        userDocumentOwnerId: objUserTk.UserId,
        phoneNumber: collab.phoneNumber,
        signerEmail: collab.email,
        signerName: collab.name,
        signType: 1,
        hasSigned: false,
        presencialSign: false,
        photoRequired: false,
        signatureLocations: [],
      };
    });

    // Quando o documento veio de um modelo DOCX com tags {{ASSINATURAn}},
    // ignoramos os componentes de drag-and-drop e usamos as posições
    // extraídas pelo backend, mapeadas pela ordem dos signatários.
    if (templatePlaceholders && templatePlaceholders.length > 0) {
      const orderedPlaceholders = [...templatePlaceholders].sort(
        (a, b) => (a.index ?? 0) - (b.index ?? 0),
      );

      collaborators.forEach((collab, idx) => {
        const ph = orderedPlaceholders[idx];
        if (!ph) return;
        groupedByEmail[collab.email].signatureLocations = [
          {
            positonX: ph.x,
            postionY: ph.y,
            pageNumber: ph.page,
            width: ph.width,
            height: ph.height,
            adjustY: false,
          },
        ];
      });

      return Object.values(groupedByEmail);
    }

    components.forEach((item) => {
      const {
        position,
        pageNum,
        email: signerEmail,
        addToContacts,
        sendMessageWhatsApp,
        requireSignerDocument,
        signPosition,
        phoneNumber,
        text: signerName,
      } = item;

      if (!groupedByEmail[signerEmail]) {
        groupedByEmail[signerEmail] = {
          addToContacts,
          sendMessageWhatsApp,
          requireSignerDocument,
          signPosition,
          disableAutoSign:
            collaborators.find((c) => c.email === signerEmail)
              ?.disableAutoSign ?? false,
          userDocumentOwnerId: objUserTk.UserId,
          phoneNumber,
          signerEmail,
          signerName,
          signType: 1,
          hasSigned: false,
          presencialSign: false,
          photoRequired: false,
          signatureLocations: [],
        };
      }

      groupedByEmail[signerEmail].signatureLocations.push({
        positonX: position.x,
        postionY: position.y,
        pageNumber: pageNum + 1,
        width: 200,
        height: 70,
      });
    });

    return Object.values(groupedByEmail);
  }

  async function convertToBase64(input) {
    if (typeof input === "string") {
      if (input.startsWith("data:")) {
        return input;
      } else if (input.startsWith("blob:")) {
        try {
          const response = await fetch(input);
          const blob = await response.blob();
          return convertBlobToBase64(blob);
        } catch (error) {
          throw new Error(
            "Não foi possível ler o arquivo do navegador (blob).",
          );
        }
      } else if (/^[A-Za-z0-9+/=]+$/.test(input)) {
        // Caso venha apenas o conteúdo base64 sem prefixo data:
        return `data:application/pdf;base64,${input}`;
      } else {
        throw new Error(
          "Entrada inválida. A string fornecida não é Base64 nem uma URL válida.",
        );
      }
    } else if (input instanceof Blob || input instanceof File) {
      return convertBlobToBase64(input);
    } else {
      throw new Error(
        "Tipo de entrada inválido. Deve ser uma string, Blob ou File.",
      );
    }
  }

  function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  const validationSign = () => {
    if (collaborators.length === 0) {
      showToast("info", "Adicione pelo menos um signatário");
      return false;
    }

    if (
      templatePlaceholders &&
      templatePlaceholders.length > 0 &&
      collaborators.length !== templatePlaceholders.length
    ) {
      showToast(
        "info",
        `Este modelo exige ${templatePlaceholders.length} signatário(s). Você adicionou ${collaborators.length}.`,
      );
      return false;
    }

    const collaboratorEmails = new Set(collaborators.map((c) => c.email));
    const componentEmails = new Set(components.map((c) => c.email));

    const orphanPositions = [...componentEmails].filter(
      (email) => !collaboratorEmails.has(email),
    );

    if (orphanPositions.length > 0) {
      showToast(
        "info",
        `Os seguintes emails posicionados não estão na lista de signatários: ${orphanPositions.join(", ")}`,
      );
      return false;
    }

    const nameMismatch = components.some((component) => {
      const matchingCollaborator = collaborators.find(
        (collab) => collab.email === component.email,
      );
      return (
        matchingCollaborator && matchingCollaborator.name !== component.text
      );
    });

    if (nameMismatch) {
      showToast("info", "Alguns nomes não correspondem aos emails");
      return false;
    }

    const signatureMap = new Map();

    for (const comp of components) {
      const key = `${comp.email}-${comp.pageNum}`;

      if (signatureMap.has(key)) {
        showToast(
          "info",
          `O signatário ${
            comp.email
          } possui 2 ou mais assinatura/visto na página ${comp.pageNum + 1}`,
        );
        return false;
      }

      signatureMap.set(key, true);
    }

    return true;
  };

  async function saveSigners() {
    if (!validationSign()) return;

    try {
      if (!pdf) {
        showToast(
          "error",
          "PDF não encontrado. Recarregue o arquivo e tente novamente.",
        );
        return;
      }

      const base64Pdf = await convertToBase64(pdf);
      const idDocument = await createDocument([base64Pdf]);
      if (idDocument === "nonename") {
        return;
      }

      if (idDocument) {
        const signerActionsRequest = buildSignerActionsRequest(components);

        const obj = {
          documentOwnerName: objUserTk.UserName,
          documentOwnerEmail: objUserTk.email,
          userId: objUserTk.UserId,
          documentId: idDocument,
          signerActionsRequest,
          messageTitle,
          messageEmailBody,
        };

        await createDocumentSignType(obj);

        setPdf(null);
        setTotalPages(0);
        setPageNum(0);
        setPageDetails(null);
        setComponents([]);
        setCollaborators([]);
        setNameDocument("");
        setTemplatePlaceholders(null);
        setTemplateRequiredSignersCount(0);

        navigate("/admin/index");
      }
    } catch (error) {
      console.error("Erro ao preparar/enviar documento:", error);
      showToast(
        "error",
        "Falha ao preparar o PDF para envio. Recarregue o arquivo e tente novamente.",
      );
    }
  }

  async function updateSigners() {
    if (validationSign()) {
      const signerActionsRequest = buildSignerActionsRequest(components);

      const obj = {
        documentOwnerName: objUserTk.UserName,
        documentOwnerEmail: objUserTk.email,
        documentId: idEditDocument,
        signerActionsRequest,
        messageTitle,
        messageEmailBody,
      };

      setIdEditDocument("");
      await updateDocumentSignType(obj);

      setPdf(null);
      setTotalPages(0);
      setPageNum(0);
      setPageDetails(null);
      setComponents([]);
      setNameDocument("");
      setTemplatePlaceholders(null);
      setTemplateRequiredSignersCount(0);

      navigate("/admin/index");
    }
  }

  const handleEnd = (e, data, id, pageNum, typeSign) => {
    setComponents((prev) =>
      prev.map((comp) =>
        comp.id === id
          ? { ...comp, position: { x: data.x, y: data.y }, pageNum, typeSign }
          : comp,
      ),
    );
  };

  // const handleCancel = (id) => {

  //   Swal.fire({
  //     title: "Tem certeza?",
  //     text: `Você está prestes a excluir o componente com ID: ${id}.`,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Sim, exclua!",
  //     cancelButtonText: "Cancelar",
  //   }).then((result) => {
  //     if (result.isConfirmed)
  //       setBlurEnabled(!blurEnabled);
  //       setComponents((prev) => prev.filter((comp) => comp.id !== id));
  //   });

  // };

  const handleCancel = (id) => {
    setBlurEnabled(true);
    setComponents((prev) => prev.filter((comp) => comp.id !== id));
  };

  const handleCopy = (id, pageNumber) => {
    const selectedComponent = components.find((comp) => comp.id === id);

    if (selectedComponent) {
      const storageKey = `${id}-typeSign`;
      const storedTypeSign = localStorage.getItem(storageKey) || "Assinatura";

      const newComponents = Array.from({ length: totalPages }, (_, index) => {
        if (index !== pageNumber) {
          return {
            ...selectedComponent,
            id: Date.now() + index,
            pageNum: index,
            dropdownOpen: false,
            typeSign: storedTypeSign,
          };
        }
        return null;
      }).filter(Boolean);

      setComponents((prev) => [...prev, ...newComponents]);
      setDropdownOpen(false);
    }
  };

  const handleCanvasClick = (
    id,
    pageNum,
    event,
    collaboratorName,
    email,
    addToContacts,
    sendMessageWhatsApp,
    requireSignerDocument,
    signPosition,
    phoneNumber,
    typeSign,
  ) => {
    const { offsetX, offsetY } = event.nativeEvent;

    if (blurEnabled) {
      setDropdownOpen(true);
      addDraggableText(
        pageNum,
        offsetX,
        offsetY,
        collaboratorName,
        email,
        addToContacts,
        sendMessageWhatsApp,
        requireSignerDocument,
        signPosition,
        phoneNumber,
        typeSign,
      );
      setBlurEnabled(!blurEnabled);
    }
  };

  const addDraggableText = (
    pageNum,
    clickX,
    clickY,
    collaboratorName,
    email,
    addToContacts,
    sendMessageWhatsApp,
    requireSignerDocument,
    signPosition,
    phoneNumber,
    typeSign,
  ) => {
    setComponents((prevComponents) => {
      const id = prevComponents.length + 1;

      return [
        ...prevComponents,
        {
          id,
          type: "text",
          text: collaboratorName,
          email: email,
          addToContacts: addToContacts,
          sendMessageWhatsApp: sendMessageWhatsApp,
          requireSignerDocument: requireSignerDocument,
          signPosition: signPosition,
          phoneNumber: phoneNumber,
          position: { x: clickX, y: clickY },
          pageNum,
          typeSign: typeSign,
        },
      ];
    });
  };

  const addDraggableSetInfo = (
    collaboratorName,
    email,
    phoneNumber,
    addToContacts,
    sendMessageWhatsApp,
    requireSignerDocument,
    signPosition,
    typeSign,
    id,
  ) => {
    setComponents((prevComponents) => {
      const targetComponent = prevComponents.find(
        (component) => component.id === id,
      );

      return prevComponents.map((component) => {
        if (component === targetComponent) {
          return {
            ...component,
            text: collaboratorName,
            email: email,
            phoneNumber: phoneNumber,
            addToContacts: addToContacts,
            sendMessageWhatsApp: sendMessageWhatsApp,
            requireSignerDocument: requireSignerDocument,
            signPosition: signPosition,
            typeSign: typeSign,
          };
        }
        return component;
      });
    });
    setBlurEnabled(!blurEnabled);
  };

  const toggleBlur = () => {
    setBlurEnabled(!blurEnabled);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const [mouseDownPosition, setMouseDownPosition] = useState(null);

  const handleMouseDown = (event) => {
    setMouseDownPosition({ x: event.clientX, y: event.clientY });
  };

  const handleMouseUp = (event, index) => {
    const threshold = 5;
    const { clientX, clientY } = event;

    if (
      mouseDownPosition &&
      Math.abs(mouseDownPosition.x - clientX) < threshold &&
      Math.abs(mouseDownPosition.y - clientY) < threshold
    ) {
      handleCanvasClick(
        components[0]?.id,
        index,
        event,
        selectedCollaboratorName,
        selectedCollaboratorEmail,
        selectedCollaboratorAddToContacts,
        selectedCollaboratorSendMessageWhatsApp,
        selectedCollaboratorRequireSignerDocument,
        selectedCollaboratorSignPosition,
        selectedCollaboratorPhoneNumber,
      );
    }
    setMouseDownPosition(null);
  };

  const steps = [
    {
      target: "#pdf-container",
      content:
        "Clique no local do documento onde deseja inserir a assinatura. Em seguida, selecione o signatário no menu suspenso e escolha o tipo de assinatura.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "#button-send-document",
      content:
        "Clique aqui para enviar o documento para assinatura após posicionar todas as assinaturas.",
      placement: "bottom",
      disableBeacon: true,
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if (status === "finished" || status === "skipped") {
      setTutorial(false);
    }
  };

  return (
    <div>
      <Joyride
        steps={steps}
        run={tutorial}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        locale={{
          last: "Finalizar",
          next: "Próximo",
          back: "Voltar",
          skip: "Pular",
          close: "Fechar",
        }}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: "#F9B233",
            textColor: "#333",
            arrowColor: "#fff",
            backgroundColor: "#fff",
          },
        }}
      />

      <div style={{ filter: blurEnabled ? "blur(5px)" : "none" }}></div>

      {templatePlaceholders && templatePlaceholders.length > 0 && (
        <div
          style={{
            margin: "0 0 12px 0",
            padding: "12px 16px",
            background: "#e9f7fd",
            border: "1px solid #F9B233",
            borderLeft: "4px solid #F9B233",
            borderRadius: 8,
            color: "#154a5f",
            fontSize: 14,
          }}
        >
          <strong>Posições de assinatura definidas pelo modelo</strong>
          <div style={{ marginTop: 4 }}>
            Foram identificadas <strong>{templatePlaceholders.length}</strong>{" "}
            posições de assinatura a partir das tags{" "}
            <code>{"{{ASSINATURAn}}"}</code> do modelo. Não é necessário
            posicionar manualmente no documento — basta clicar em{" "}
            <strong>Enviar para Assinatura</strong>.
          </div>
        </div>
      )}

      <Row
        className={`pdf-editor-row${signMobilePageScroll ? " pdf-editor-row--sign-mobile" : ""}`}
        style={{
          margin: "0",
        }}
      >
        <Col
          lg={location.pathname !== "/admin/sign-document" ? "9" : "12"}
          className="mt-2 pdf-editor-col-main"
        >
          {/* pdf */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            {!pdf && !routeSign && (
              <Drop
                onLoaded={async (files) => setPdf(await blobToURL(files[0]))}
              />
            )}
            <div>
              <div className="w-full h-600">
                <Modal
                  isOpen={isOpen}
                  toggle={handleClose}
                  size="xl"
                  className="modal-fullscreen"
                >
                  <ModalBody className="p-0">
                    <iframe
                      src={pdf}
                      title="PDF Viewer"
                      className="w-100"
                      frameBorder="0"
                      style={{ height: "90vh" }}
                    />
                  </ModalBody>
                </Modal>
              </div>

              {pdf && !routeSign && !idEditDocument && !toEdit && (
                <div className="pdf-editor-actions">
                  <BigButton
                    title={"<- Voltar"}
                    onClick={() => {
                      navigate("/admin/add-signatories");
                    }}
                    style={{ flex: "0 0 auto" }}
                  />
                  <Button
                    id="button-send-document"
                    className="button-login pdf-editor-send-btn"
                    onClick={() => saveSigners()}
                  >
                    Enviar para Assinatura
                  </Button>
                  <div
                    className="fullscreen-link"
                    onClick={handleOpen}
                    style={{ width: "100%", marginTop: 4 }}
                  >
                    <span
                      style={{
                        color: "#446a8fad",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <FullscreenExitIcon />
                      Abrir em tela cheia
                    </span>
                  </div>
                </div>
              )}

              {toEdit && pdf && (
                <div className="pdf-editor-actions">
                  <BigButton
                    title={"<- Voltar"}
                    onClick={() => {
                      window.history.back();
                    }}
                    style={{ flex: "0 0 auto" }}
                  />
                  <Button
                    className="button-login pdf-editor-send-btn"
                    onClick={() => updateSigners()}
                  >
                    Salvar Edições
                  </Button>
                </div>
              )}

              <div
                id="document-page"
                ref={documentRef}
                className={signMobilePageScroll ? "pdf-editor-sign-page" : ""}
                style={{
                  margin: "8px auto 20px",
                  position: "relative",
                }}
              >
                {pdf && (
                  <div id="pdf-container">
                    <Document
                      file={pdf}
                      onLoadSuccess={(data) => setTotalPages(data.numPages)}
                      id="document-page"
                    >
                      {Array.from({ length: totalPages }, (_, index) => (
                        <div
                          id={`document-page-${index + 1}`}
                          key={index}
                          style={{
                            marginBottom: "20px",
                            border: "1px solid rgb(153, 153, 153)",
                            boxSizing: "border-box",
                            cursor: isMobileDevice ? "default" : "pointer",
                          }}
                          {...(!isMobileDevice && {
                            onMouseDown: handleMouseDown,
                            onMouseUp: (e) => handleMouseUp(e, index),
                          })}
                        >
                          {!routeSign &&
                            !isMobileDevice &&
                            components
                              .filter((comp) => comp.pageNum === index)
                              .map((comp) => (
                                <DraggableText
                                  collaborators={collaborators}
                                  id={comp.id}
                                  key={comp.id}
                                  onEnd={(e, data) =>
                                    handleEnd(
                                      e,
                                      data,
                                      comp.id,
                                      comp.pageNum,
                                      comp.typeSign,
                                    )
                                  }
                                  onCancel={() => handleCancel(comp.id)}
                                  onCopy={() =>
                                    handleCopy(
                                      comp.id,
                                      comp.pageNum,
                                      comp.typeSign,
                                    )
                                  }
                                  initialText={comp.text}
                                  position={comp.position}
                                  pageNum={comp.pageNum}
                                  totalNumPages={totalPages}
                                  pageDetails={pageDetails}
                                  documentRef={documentRef}
                                  typeSign={comp.typeSign}
                                  dropdownOpen={dropdownOpen}
                                  setComponents={setComponents}
                                  onAddSignature={(
                                    id,
                                    name,
                                    email,
                                    phoneNumber,
                                    addToContacts,
                                    sendMessageWhatsApp,
                                    requireSignerDocument,
                                    signPosition,
                                    typeSig,
                                  ) => {
                                    addDraggableSetInfo(
                                      name,
                                      email,
                                      phoneNumber,
                                      addToContacts,
                                      sendMessageWhatsApp,
                                      requireSignerDocument,
                                      signPosition,
                                      typeSig,
                                      comp.id,
                                    );
                                    setSelectedCollaboratorName(name);
                                    setSelectedCollaboratorEmail(email);
                                    setSelectedCollaboratorPhoneNumber(
                                      phoneNumber,
                                    );
                                    setSelectedCollaboratorAddToContacts(
                                      addToContacts,
                                    );
                                    setSelectedCollaboratorSendMessageWhatsApp(
                                      sendMessageWhatsApp,
                                    );
                                    setSelectedCollaboratorRequireSignerDocument(
                                      requireSignerDocument,
                                    );
                                    setSelectedCollaboratorSignPosition(
                                      signPosition,
                                    );
                                  }}
                                />
                              ))}
                          <Page
                            pageNumber={index + 1}
                            width={
                              window.innerWidth < 768
                                ? window.innerWidth - 32
                                : routeCreateOrUpdateDocument
                                  ? undefined
                                  : 800
                            }
                            onLoadSuccess={(data) => setPageDetails(data)}
                          />
                        </div>
                      ))}
                    </Document>
                  </div>
                )}
              </div>
              {pdf && !routeSign && !idEditDocument && !isSpecificRoute && (
                <div className="pdf-editor-actions">
                  <BigButton
                    title={"<- Voltar"}
                    onClick={() => {
                      navigate("/admin/add-signatories");
                    }}
                    style={{ flex: "0 0 auto" }}
                  />
                  <Button
                    className="button-login pdf-editor-send-btn"
                    onClick={() => saveSigners()}
                  >
                    Enviar para Assinatura
                  </Button>
                </div>
              )}

              {isSpecificRoute && pdf && (
                <div className="pdf-editor-actions">
                  <BigButton
                    title={"<- Voltar"}
                    onClick={() => {
                      window.history.back();
                    }}
                    style={{ flex: "0 0 auto" }}
                  />
                  <Button
                    className="button-login pdf-editor-send-btn"
                    onClick={() => updateSigners()}
                  >
                    Salvar Edições
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Col>
        {location.pathname !== "/admin/sign-document" && !isMobileDevice && (
          <Col
            lg="3"
            className="pdf-editor-col-sidebar"
            style={{ height: "auto" }}
          >
            <div
              style={{
                height: "100%",
                //   filter: blurEnabled ? "blur(5px)" : "none",
                //   position: "relative",
              }}
            >
              <TodoList
                saveSigners={saveSigners}
                updateSigners={updateSigners}
                routeSign={routeSign}
                onAddSignature={(index) => {
                  const collaboratorName = collaborators[index]?.name;
                  const collaboratorEmail = collaborators[index]?.email;
                  const newCollaboratorPhoneNumber =
                    collaborators[index]?.phoneNumber;
                  const newCollaboratorAddToContacts =
                    collaborators[index]?.addToContacts;
                  const newCollaboratorSendMessageWhatsApp =
                    collaborators[index]?.sendMessageWhatsApp;
                  const newCollaboratorRequireSignerDocument =
                    collaborators[index]?.requireSignerDocument;
                  const newCollaboratorSignPosition =
                    collaborators[index]?.signPosition;
                  toggleBlur();
                  setSelectedCollaboratorName(collaboratorName);
                  setSelectedCollaboratorEmail(collaboratorEmail);
                  setSelectedCollaboratorPhoneNumber(
                    newCollaboratorPhoneNumber,
                  );
                  setSelectedCollaboratorAddToContacts(
                    newCollaboratorAddToContacts,
                  );
                  setSelectedCollaboratorSendMessageWhatsApp(
                    newCollaboratorSendMessageWhatsApp,
                  );
                  setSelectedCollaboratorRequireSignerDocument(
                    newCollaboratorRequireSignerDocument,
                  );
                  setSelectedCollaboratorSignPosition(
                    newCollaboratorSignPosition,
                  );
                }}
                onAddDate={() => {
                  const id = components.length + 1;
                  setComponents([
                    ...components,
                    { id, type: "date", position: { x: 0, y: 0 }, pageNum },
                  ]);
                }}
                onAddText={(
                  index,
                  email,
                  newText,
                  email2,
                  addToContacts,
                  sendMessageWhatsApp,
                  requireSignerDocument,
                  signPosition,
                  phoneNumber,
                  typeSign,
                ) => {
                  const id = components.length + 1;
                  setComponents([
                    ...components,
                    {
                      id,
                      type: "text",
                      text: newText,
                      email: email2,
                      position: { x: 0, y: 0 },
                      pageNum,
                      addToContacts,
                      sendMessageWhatsApp,
                      requireSignerDocument,
                      signPosition,
                      phoneNumber,
                      typeSign,
                    },
                  ]);
                }}
                setPageNum={setPageNum}
                onReset={() => {
                  setPdf(null);
                  setTotalPages(0);
                  setPageNum(0);
                  setPageDetails(null);
                  setComponents([]);
                }}
              />
            </div>
          </Col>
        )}
      </Row>
      <div style={{ filter: blurEnabled ? "blur(5px)" : "none" }}></div>

      <style>{`
        .pdf-editor-actions {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin: 0 0 12px;
        }
        .pdf-editor-send-btn {
          flex: 1;
          min-width: 180px;
          max-width: 350px;
        }
        @media (max-width: 768px) {
          .pdf-editor-row {
            flex-direction: column-reverse !important;
            overflow-x: hidden !important;
          }
          /* Evita painel com scroll interno: overflow-x:hidden força overflow-y:auto no eixo oposto. */
          .pdf-editor-row--sign-mobile {
            overflow: visible !important;
          }
          .pdf-editor-row--sign-mobile .pdf-editor-col-main {
            overflow: visible !important;
          }
          .pdf-editor-col-sidebar {
            order: -1;
            margin-bottom: 12px;
          }
          .pdf-editor-col-sidebar .todo-list-container {
            position: static !important;
            height: auto !important;
            max-height: 200px;
            padding: 12px;
          }
          .pdf-editor-actions {
            flex-direction: column;
            align-items: stretch;
          }
          .pdf-editor-send-btn {
            max-width: 100% !important;
            width: 100% !important;
          }
          .pdf-editor-col-main {
            padding-left: 0 !important;
            padding-right: 0 !important;
            overflow-x: hidden !important;
          }
          #document-page {
            margin-left: 0 !important;
            margin-right: 0 !important;
            overflow-x: auto !important;
            max-width: 100vw;
          }
          #document-page.pdf-editor-sign-page {
            overflow: visible !important;
            overflow-x: visible !important;
            max-width: 100% !important;
          }
          #document-page.pdf-editor-sign-page #pdf-container {
            overflow: visible !important;
            overflow-x: visible !important;
            max-width: 100%;
          }
          #document-page.pdf-editor-sign-page .react-pdf__Page {
            touch-action: pan-y pinch-zoom;
          }
          #document-page.pdf-editor-sign-page .react-pdf__Page canvas {
            touch-action: pan-y pinch-zoom;
          }
          #pdf-container {
            max-width: 100%;
            overflow-x: auto;
          }
          .react-pdf__Page {
            max-width: 100% !important;
          }
          .react-pdf__Page canvas {
            max-width: 100% !important;
            height: auto !important;
          }
        }
      `}</style>
    </div>
  );
}

export default PdfEditor;
